import { GET_PROFILE } from '../actions/types';
import { PostDispatch } from '../types';

const ProfileReducer = (state = null, action: PostDispatch) => {
    switch (action.type) {
        case GET_PROFILE:
            return action.payload;
        default:
            return state;
    }
};

export default ProfileReducer;
